import React from "react"
import { Polygon as SvgPolygon, Svg } from "react-native-svg"
import { connect } from "react-redux"
import type { PolygonProps as SvgPolygonProperties } from "react-native-svg"
import type { ConnectedProps } from "react-redux"
import type { FieldIdProps } from "@/redux/models"
import type { RootState } from "@/redux/root.reducer"
import * as Models from "@/redux/models"
import { useFieldColors } from "@/redux/user-preferences.reducer"
import { Theme } from "@/theme"
import { withErrorBoundary } from "./withErrorBoundary"

interface OwnProps
  extends Omit<SvgPolygonProperties, "height" | "id" | "points" | "width"> {
  height?: number
  width?: number
}

const connector = connect(
  (state: RootState, { fieldId, ...rest }: FieldIdProps & OwnProps) => {
    const field = Models.farmField.selectById(state, fieldId)
    return { fieldId, ...rest, ...field?.svgInfo }
  },
  {},
)

export const FieldSvgComponent = React.memo(function FieldSvgComponent({
  fieldId,
  points,
  viewbox,
  ...rest
}: ConnectedProps<typeof connector>): React.JSX.Element | null {
  const { svgColor } = useFieldColors()

  const width = rest.width ?? rest.height ?? 60
  const height = rest.height ?? rest.width ?? 60

  if (typeof points === "string" && typeof viewbox === "string") {
    return (
      <Svg
        height={height}
        testID={`svg-${fieldId}`}
        viewBox={viewbox}
        width={width}
        {...rest}
      >
        <SvgPolygon
          fill={svgColor}
          points={points}
          stroke={Theme.COLORS.$black}
          strokeWidth={0.00004}
        />
      </Svg>
    )
  }
  return null
})
export const FieldSvgConnected = withErrorBoundary(
  connector(FieldSvgComponent),
  {},
)
